<i18n>
de:
  Get directions: Ort suchen / Route berechnen
</i18n>
<template>
  <v-tooltip bottom>
    <template #activator="{ on: tooltip }">
      <v-btn icon :dark="dark"  v-on="{ ...tooltip }" @click="toggleUi">
        <v-icon medium>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ $t(hoverText) }}</span>
  </v-tooltip>

</template>

<script>
import { WguEventBus } from '../../WguEventBus'

export default {
  name: 'wgu-routing-btn',
  props: {
    active: {type: Boolean, required: false, default: false},
    dark: {type: Boolean, required: false, default: false},
    icon: {type: String, required: false, default: 'search'},
    hoverText: {type: String, required: false, default: 'Get directions'},
    toggleGroup: {type: String, required: false, default: undefined}
  },
  data: function () {
    return {
      moduleName: 'wgu-routing',
      state: this.active,
      checkStatus: true
    }
  },
  created () {
    window.RoutingToggleButton = this;
    // When member of toggle group: close if any other panel active
    if (this.toggleGroup) {
      WguEventBus.$on(this.toggleGroup, ({ moduleName, state }) => {
        this.state = moduleName === this.moduleName && state;
      });
    }
    WguEventBus.$on('close-direction-menu', state => {
      this.checkStatus = state
    })
  },
  methods: {
    toggleUi () {
      if (this.checkStatus === false) {
        this.state = true
        this.checkStatus = true
      } else {
        this.state = !this.state;
      }
      WguEventBus.$emit('toggle-routing-panel', this.state);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/routing/RoutingToggleButton.vue